const SELECTOR_PLAYLIST_CONTAINER = ".js-playlist-container";
const COMPLETED_THRESHOLD = 90;

export function updateThumbnailState(
  lessonId: string,
  progressPercentage: number,
  state = "completed"
): void {
  const container = document.querySelector<HTMLElement>(
    SELECTOR_PLAYLIST_CONTAINER
  );

  if (!container || !lessonId || progressPercentage < COMPLETED_THRESHOLD)
    return;

  const item = container.querySelector(`[data-lesson-id='${lessonId}']`);
  if (!item) return;

  const thumbnail = item.querySelector<HTMLElement>("figure");

  if (!thumbnail) return;

  thumbnail.setAttribute("data-status", state);
  thumbnail
    .querySelector("svg.js-completed-icon")
    ?.classList.remove("tw-hidden");
}
